import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

// The state for requesting an update on Intermediaries' reports table
export const STATE_REPORT_UPDATING = atom<boolean>({
    key: "intermediaries-state-report-updating",
    default: false
});

export const STATE_REPORT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'intermediaries-state-report-active-filters',
    default: []
});
export const STATE_PRINTOUT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'intermediaries-state-printout-active-filters',
    default: []
});
export const STATE_PREVIEW_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'intermediaries-state-preview-active-filters',
    default: []
});

export const STATE_REPORT_TOTAL_COUNT = atom<any>({
    key: 'intermediaries-state-report-total-count',
    default: null
});

export const STATE_PRINTOUT_TOTAL_COUNT = atom<any>({
    key: 'intermediaries-state-printout-total-count',
    default: null
});